import moment from 'moment'

/**
 * Get the earliest one of two dates. Unexpected input will result in either returning one valid date or NULL if both
 * dates are not as expected. Both parameters are set to NULL by default to prevent unwanted auto-casting to 'now' by
 * moment(undefined).
 *
 * @param {String|moment.Moment} [firstDate=null] - Date as ISO 8601 string or moment object.
 * @param {String|moment.Moment} [secondDate=null] - Reference date as ISO 8601 string or moment object.
 * @returns {String|null} An ISO 8601 formatted date string or null.
 */
export function earliestOfTwoDates(firstDate = null, secondDate = null) {
    const castedDate = moment.isMoment(firstDate) ? firstDate : moment(firstDate)
    const castedReferenceDate = moment.isMoment(secondDate) ? secondDate : moment(secondDate)

    if (castedDate.isValid() && castedReferenceDate.isValid()) {
        return castedDate.isBefore(castedReferenceDate) ? castedDate.toISOString() : castedReferenceDate.toISOString()
    }

    if (castedDate.isValid()) {
        return castedDate.toISOString()
    }

    if (castedReferenceDate.isValid()) {
        return castedReferenceDate.toISOString()
    }

    return null
}
